<template>
  <v-form @submit.prevent="submit"
          ref="form">
    <v-card>
      <v-card-title>
        New Fax Contact
      </v-card-title>
      <v-card-text>
        <fax-contact-form :form="form">
        </fax-contact-form>
      </v-card-text>
      <v-card-actions>
        <v-btn type="submit"
               color="primary">
          Create
        </v-btn>
        <v-btn @click.prevent="closeDialog">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import {Form} from 'vform';
import faxService from '../../../../services/faxService';
import FaxContactForm from "./FaxContactForm";
import DOMPurify from 'dompurify';

export default {
  components: {FaxContactForm},
  data() {
    return {
      form: new Form({
        company_name: '',
        fax_number: '',
        name: '',
      })
    }
  },
  methods: {
    submit() {
      faxService.createContact(this.form)
        .then(contact => {
          this.$refs.form.resetValidation();
          this.form.clear();
          this.form.reset();
          setTimeout(() => {
            this.$emit('updated', contact)
          }, 500);
        })
        .catch(err => {
          this.$toast.error(DOMPurify.sanitize(err.response.data.message));
        })
    },
    closeDialog() {
      this.$emit('close');
    }
  }
}
</script>
